export enum AuthorizationPolicy {
  Users = "users",
  TrainingProgramStakeholders = "trainingProgramStakeholders",
  Administrators = "administrators",
}
